import React, { Component } from 'react';
import { styled } from '@material-ui/core/styles';
import { Box, Button, TextField, MenuItem } from '@material-ui/core';

const Root = styled(Box)({
    width: '405px',
    height: '100%',
    padding: '26px',
    '& .title': {
        color: '#9B9B9B',
        fontSize: '14px',
    },
    '& .line': {
        width: '100%',
        height: '1px',
        backgroundColor: '#D8D8D8',
        margin: '16px 0',
    },
    '& .sliderWapper': {
        margin: '25px 0',
        '& .slider': {
            margin: '0 18px',
        },
    },
    '& .textField': {
        width: '100%',
        margin: '10px 0',
    },
    '& .footer': {
        width: '353px',
        position: 'absolute',
        bottom: '25px',
        '& .btn': {
            width: '100%',
            marginTop: '18px',
        },
    },
})

class SideList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            attorney: "",
            attorneyData: [],
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleClear = this.handleClear.bind(this);
        this.handleApply = this.handleApply.bind(this);
    }
    render() {
        const {
            attorney,
            attorneyData,
        } = this.state;
        return (
            <Root>
                <div className="filters h h-r">
                    <div>Filters</div>
                </div>
                <div className="line"></div>
                <div className="title">SALARY AMOUNT</div>
                <TextField
                    id="outlined-select-currency"
                    select
                    label="Choose Originating Attorney "
                    className="textField"
                    value={attorney}
                    onChange={e => this.handleChange(e, 'attorney')}
                    margin="dense"
                    variant="outlined"
                >
                    {attorneyData.map(option => (
                        <MenuItem key={option.id} value={option.attorney}>
                            {option.attorney}
                        </MenuItem>
                    ))}
                </TextField>
                <div className="footer v c">
                    <div className="line"></div>
                    <Button className="btn" variant="contained" onClick={this.handleClear}>CLEAR</Button>
                    <Button className="btn" variant="contained" color="primary" onClick={this.handleApply}>APPLY FILTERS</Button>
                </div>
            </Root>
        )
    }
    componentDidMount() {
    }
    initAdminData() {
        const data = localStorage.getItem("");
        console.log(data);
        // if () {
        const attorney = data.handler_department.attorney;
        this.setState(() => ({
            attorney,
        }));
        // }
    }
    handleChange(e, name) {
        const value = e.target.value;
        this.setState(() => ({
            [name]: value
        }))
    }
    handleClear() {
        this.clearData();
    }
    handleApply() {
        const {
            attorney,
        } = this.state;
        let obj = {
            attorney,
        };
        this.props.handleApply(obj);
    }
    clearData() {
        this.setState(() => ({
            attorney: "",
        }))
    }
}

export default SideList;